exports.MESSENGER_COLORS = {
    "telegram": "#1fa0e1",
    "whatsup": "#4caf50",
};
